import { render } from "./transfered_products.vue?vue&type=template&id=3d424351&scoped=true"
import script from "./transfered_products.vue?vue&type=script&lang=js"
export * from "./transfered_products.vue?vue&type=script&lang=js"

import "./transfered_products.vue?vue&type=style&index=0&id=3d424351&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d424351"]])

export default __exports__